<template>
    <div class="tabs-bar">
        <div :class="['item', active == index ? 'active' : '']" v-for="(tab, index) in tabs" @click="goLink(tab.url)"
            :key="index">{{ tab.name }}</div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            default: () => [] // [{name: '', url: ''}]
        },
        active: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {}
    },
    methods: {
        goLink(url) {
            window.location.href = url;
        }
    }
}
</script>


<style lang="scss">
.tabs-bar {
    padding: 30px 0 20px;
    background-color: $--color-white;
    border-radius: 0 0 10px 10px;
    display: flex;

    .item {
        margin: 0 25px;
        font-size: 18px;
        font-weight: bold;
        color: $-text-500;
        cursor: pointer;
        position: relative;

        &::after {
            content: "";
            position: absolute;
            height: 2px;
            width: 100%;
            bottom: -20px;
            left: 0px;
            background-color: $--color-white;
        }

        &.active {
            color: $--color-base;

            &::after {
                background-color: $--color-base;
            }
        }
    }
}
</style>